import i18n from '../../lang/index'
const serverRouter = [{
  path: '/server',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'serverindex'
  },
  children: [{
      name: 'serverindex',
      path: 'index',
      component: () => import('@/pages/server/Index'),
      redirect: {
        name: 'serverlist'
      },
      children: [{
          name: 'serverlist',
          path: 'instance',
          meta: {
            tab: 'instance',
            title: i18n.t('ecc.title'),
          },
          component: () => import('@/pages/server/InstancList'),
        },
        {
          path: 'storage',
          name: 'storagelist',
          meta: {
            tab: 'storage',
            title: i18n.t('ecc.storage.name'),
          },
          component: () => import('@/pages/server/StorageList'),
        },
        {
          path: 'snapshots',
          name: 'snapshotlist',
          meta: {
            tab: 'snapshots',
            title: i18n.t('ecc.snapshot.name'),
          },
          component: () => import('@/pages/server/SnapshotList'),
        }, {
          path: 'automatic',
          name: 'automaticlist',
          meta: {
            tab: 'automatic',
            title: i18n.t('ecc.snapshotPolicy.name'),
          },
          component: () => import('@/pages/server/Automatic'),
        },
        {
          path: 'bandwidth',
          name: 'bandwidthlist',
          meta: {
            tab: 'bandwidth',
            title: i18n.t('ecc.ip.name'),
          },
          component: () => import('@/pages/server/Bandwidth'),
        }, {
          path: 'groups',
          name: 'groupslist',
          meta: {
            tab: 'groups',
            title: i18n.t('ecc.securityGroup.name'),
          },
          component: () => import('@/pages/server/Groups'),
        }, {
          path: 'intranet',
          name: 'intranetlist',
          meta: {
            tab: 'intranet',
            title: i18n.t('ecc.intranet.name'),
          },
          component: () => import('@/pages/server/Intranet'),
        }
      ]
    },
    {
      name: 'serverdetail',
      path: 'index/Instance/detail',
      meta: {
        tab: 'instance',
        title: i18n.t('ecc.title'),
      },
      component: () => import('@/pages/server/InstanceDetail'),
    }, {
      name: 'intranetdetail',
      path: 'index/intranet/detail',
      meta: {
        tab: 'intranet',
        title: i18n.t('ecc.intranet.name'),
      },
      component: () => import('@/pages/server/IntranetDetail'),
    },
    {
      name: 'groupdetail',
      path: 'index/groups/detail',
      meta: {
        tab: 'groups',
        title: i18n.t('ecc.securityGroup.name'),
      },
      component: () => import('@/pages/server/GroupsDetail'),
    },
    {
      name: 'storagedetail',
      path: 'index/storage/detail',
      meta: {
        tab: 'storage',
        title: i18n.t('ecc.storage.name'),
      },
      component: () => import('@/pages/server/StorageDetail'),
    }, {
      name: 'login',
      path: 'index/login',
      meta: {
        tab: '',
        title: i18n.t('ecc.instance.pages.loginPage.header'),
      },
      component: () => import('@/pages/login/Login'),
    }
  ]
}]
export default serverRouter



// WEBPACK FOOTER //
// ./src/router/modules/server.js